import React, { useEffect, useState } from 'react';
import { Box, Button, Paper, Typography, Grid, MenuItem, TableContainer, Table, TableHead, TableBody, IconButton, Snackbar } from "@mui/material";
import { ActionMsg, Breadcrumb, Cancel, CTSinput, HandleCloseSnackbar, StyledTableCell, StyledTableRow } from "../../reusableComponent/Reusables";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import styles from "../../../styles.module.css";
import { getDriverList, getVehicleList, getCustomerList, getCylinderList, editDeletePickup, addPickup, getPickupList } from "../../../actions/actions";
import dayjs from 'dayjs';
import pickupService from '../../../services/pickup.Service';
import driverMasterService from '../../../services/masters/driverMaster.Service';
import cylinderMasterService from '../../../services/masters/cylinderMaster.Service';
import customerMasterService from "../../../services/masters/customerMaster.Service"
import vehicleMasterService from '../../../services/masters/vehicleMaster.Service';
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import depotMasterService from '../../../services/masters/depotMaster.Service';

const AddPickupentry = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { handleSubmit } = useForm();
  const location = useLocation();
  const editData = location.state || null;
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;

  const depot_id = userInfo.depot_id;
  const short_code = userInfo.short_code;

  // State imports
  // const { driver: driverList } = useSelector(state => state.driver);
  // const { vehicle: vehicleList } = useSelector(state => state.vehicle);
  // const { customer: customerList } = useSelector(state => state.customer);
  // const { cylinder: cylinderList } = useSelector(state => state.cylinder);
  // const { pickup_entry } = useSelector(state => state.pickup_entry);

  const [successMessage, setSuccessMessage] = useState("");

  const [driverList, setDriver] = useState([]);
  const [customerList, setCustomer] = useState([]);
  const [vehicleList, setVehicle] = useState([]);
  const [cylinderList, setCylinder] = useState([]);
  const [pickup_entry, setPickup_entry] = useState([]);
  const [depot, setDepot] = useState([]);
  useEffect(() => {
    async function fetchData() {
      try {
        const [driverData, customerData, cylinderData, vehicleData, pickup_entry, depotData] = await Promise.all([
          driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
          customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
          cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
          vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
          pickupService.getPickupList({ page: 0, size: 999, searchKey: "" }),
          depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
        ]);

        setDriver(driverData);
        setCustomer(customerData);
        setCylinder(cylinderData);
        setVehicle(vehicleData);
        setPickup_entry(pickup_entry);
        setDepot(depotData)

      } catch (error) {
        console.error("Data fetching failed", error);
      }
    }

    fetchData();
  }, []);

  const [data, setData] = useState({
    pickup_id: editData?.pickup_id || null,
    entry_no: editData?.entry_no || '',
    // entry_date: editData ? new Date(editData.entry_date).toISOString().split("T")[0] : new Date().toISOString().split("T")[0],
    entry_date: editData?.entry_date ? new Date(editData.entry_date).toISOString().split("T")[0] : "",
    driver_id: editData?.driver_id || '',
    from_customer_id: editData?.from_customer_id || '',
    to_tempo: editData?.to_tempo || '',
    depot: editData?.depot || [],
    fin_year: editData ? editData.fin_year : "",


  });


  const [pickupDetails, setPickupDetails] = useState(
    editData?.table_details
      ? JSON.parse(editData.table_details)
      : [{ srno: "", cyl_no: "", prod_code: "", cyl_type: "", prod_id: "" }]
  );

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "driver") {
  //     // existing driver logic
  //   } else if (name === "depot") {
  //     // Make sure depot is always an array
  //     setData(prev => ({
  //       ...prev,
  //       depot: Array.isArray(value) ? value : [value]
  //     }));
  //   } else {
  //     setData(prev => ({ ...prev, [name]: value }));
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "driver") {
      // existing driver logic
    }
    else if (name === "depot") {
      // Make sure depot is always an array
      setData(prev => ({
        ...prev,
        depot: Array.isArray(value) ? value : [value]
      }));
    }
    else {
      setData(prev => {
        const updatedData = {
          ...prev,
          [name]: value,
        };

        // Add financial year if the field is entry_date
        if (name === 'entry_date') {
          const selectedDate = new Date(value);
          const month = selectedDate.getMonth(); // Jan = 0
          const year = selectedDate.getFullYear();
          const financialYear = month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
          updatedData.fin_year = financialYear;
        }

        return updatedData;
      });
    }
  };



  const handleChangeInput = (e, index) => {
    const { name, value } = e.target;
    const updated = [...pickupDetails];
    updated[index][name] = value;

    // Update prod_code and prod_id when cyl_no changes
    if (name === "cyl_no") {
      const selectedCylinder = cylinderList.find(c => c.cylinder_no === value);
      if (selectedCylinder) {
        updated[index]["prod_code"] = selectedCylinder.prod_code || "";
        updated[index]["prod_id"] = selectedCylinder.prod_id || "";
      } else {
        updated[index]["prod_code"] = "";
        updated[index]["prod_id"] = "";
      }
    }

    setPickupDetails(updated);
  };


  const handleAddSPQuotationFields = () => {
    setPickupDetails(prev => [...prev, { srno: "", cyl_no: "", cyl_type: "" }]);
  };

  const handleRemovepickup = async (index) => {
    setPickupDetails(prev => prev.filter((_, i) => i !== index));
  };
  // const { pickup_entry = [] } = useSelector(state => state.pickup_entry || {});

  const onSubmit = async () => {
    const pickupData = {
      ...data,

      modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      modified_by: editData ? userInfo.user_id : null,
      created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      created_by: editData ? editData.created_by : userInfo.user_id,
      table_details: JSON.stringify(pickupDetails),
      changedUpdatedValue: "edit",
      depot_id: depot_id,
      short_code: short_code,
    };

    try {
      if (editData) {
        await pickupService.editDeletePickup(pickupData);
      } else {
        await pickupService.addPickup(pickupData);
      }
      setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
      setTimeout(() => navigate(-1), 1000);
      //  setTimeout(()=>navigate(-1),1000);
    } catch (error) {
      setSuccessMessage("Error occurred");
    }
  };


  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "Cylinder Collcetion Entry" }]} />

        <Box sx={{ display: "flex" }}>
          <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
            <Grid item md={7} sm={6} xs={12}>
              <Box sx={{ display: "flex" }}>
                <Typography className={`${styles.header_txt}`}>
                  Cylinder Collcetion Entry
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>


        <Box>
          <form onSubmit={handleSubmit(onSubmit)}>









            <Box sx={{ justifyContent: 'flex-end', display: 'flex', marginBottom: '20px' }}>
              {/* Last Entry No */}
              {/* Only show "Last PI No" in Add Mode */}
              {editData === null && pickup_entry && pickup_entry.length > 0 ? (
                <Typography className={`${styles.lastEntry_Txt}`}>
                  Last Entry No : {pickup_entry[0].lastScheduleEntryNo}
                </Typography>
              ) : editData === null && pickup_entry && pickup_entry.length === 0 ? (
                <Typography className={`${styles.lastEntry_Txt}`}>
                  Last Entry No : 0
                </Typography>
              ) : null}
            </Box>


            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} >
                <Grid container spacing={0.6}>

                  <Grid item xs={10} sm={10}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}>
                      <Typography
                        className={`${styles.label_Txt_add}`}>
                        From Customer
                      </Typography>
                      <CTSinput
                        select
                        size="small"
                        fullWidth
                        name="from_customer_id"
                        value={data.from_customer_id}
                        onChange={handleChange}
                        InputProps={{
                          className: styles.CTSinput_Box,
                        }}
                      >
                        {customerList?.map((c) => (
                          <MenuItem key={c.cust_id} value={c.cust_id} className={styles.cts_lable}>
                            {c.cust_name}
                          </MenuItem>
                        ))}
                      </CTSinput>

                    </Box>
                  </Grid>

                  <Grid item xs={10} sm={10}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}>
                      <Typography
                        className={`${styles.label_Txt_add}`}>
                        To Vehicle
                      </Typography>
                      <CTSinput
                        select
                        size="small"
                        fullWidth
                        name="to_tempo"
                        value={data.to_tempo}
                        onChange={handleChange}
                        InputProps={{
                          className: styles.CTSinput_Box,
                        }}
                      >
                        {vehicleList?.map((c) => (
                          <MenuItem key={c.vehicle_id} value={c.vehicle_id} className={styles.cts_lable}>
                            {c.vehicle_no}
                          </MenuItem>
                        ))}
                      </CTSinput>

                    </Box>
                  </Grid>
                </Grid>
              </Grid>


              <Grid item xs={12} sm={6} >
                <Grid container spacing={0.6}>

                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}>
                      <Typography
                        className={`${styles.label_Txt_add}`}>
                        ECR No
                      </Typography>
                      <CTSinput
                        size="small"
                        fullWidth
                        name="entry_no"
                        value={data.entry_no}
                        onChange={handleChange}

                        InputProps={{
                          readOnly: true,
                          className: styles.CTSinput_Box,
                          style: {
                            backgroundColor: "#f0f0f0",
                          },
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}>
                      <Typography
                        className={`${styles.label_Txt_add}`}>
                        ECR Date
                      </Typography>
                      <CTSinput
                        size="small"
                        fullWidth
                        type="date"
                        name="entry_date"
                        value={data.entry_date}
                        onChange={handleChange}
                        InputProps={{
                          className: styles.CTSinput_Box,
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}
                    >
                      <Typography className={`${styles.label_Txt}`}>
                        Financial Year
                      </Typography>
                      <CTSinput
                        size="small"
                        fullWidth
                        value={data.fin_year}
                        variant="outlined"
                        InputProps={{
                          readOnly: true,
                          className: styles.CTSinput_Box,
                          style: {
                            backgroundColor: "#f0f0f0",
                          },
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}>
                      <Typography
                        className={`${styles.label_Txt_add}`}>
                        Driver
                      </Typography>
                      <CTSinput
                        select
                        size="small"
                        fullWidth
                        name="driver_id"
                        value={data.driver_id}
                        onChange={handleChange}
                        InputProps={{
                          className: styles.CTSinput_Box,
                        }}
                      >
                        {driverList?.map((d) => (
                          <MenuItem key={d.driver_id} value={d.driver_id} className={styles.cts_lable}>
                            {d.driver_name}
                          </MenuItem>
                        ))}
                      </CTSinput>

                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: { xs: "stretch", sm: "center" },
                      }}
                    >
                      <Typography className={`${styles.label_Txt_add}`}>
                        Depot
                      </Typography>
                      <CTSinput
                        select
                        multiple
                        size="small"
                        fullWidth
                        name="depot"
                        value={data.depot || []}
                        onChange={handleChange}
                        InputProps={{
                          className: styles.CTSinput_Box,
                        }}
                        renderValue={(selected) =>
                          selected
                            .map((depot_id) => {
                              const item = depot.find((d) => d.depot_id === depot_id);
                              return item ? item.depot_name : depot_id;
                            })
                            .join(", ")
                        }
                      >
                        {depot?.map((d) => (
                          <MenuItem
                            key={d.depot_id}
                            value={d.depot_id}
                            className={styles.cts_lable}
                          >
                            {d.depot_name}
                          </MenuItem>
                        ))}
                      </CTSinput>
                    </Box>
                  </Grid>

                </Grid>
              </Grid>

              <Grid item xs={12}>
                <TableContainer sx={{ maxHeight: 250, minHeight: 248, mt: 1 }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell align="center" className={`${styles.table_head}`}>Sr No</StyledTableCell>
                        <StyledTableCell className={`${styles.table_head}`}>Cylinder No</StyledTableCell>
                        <StyledTableCell className={`${styles.table_head}`}>Product_code</StyledTableCell>
                        <StyledTableCell className={`${styles.table_head}`}>Cylinder Type</StyledTableCell>
                        <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>

                    <TableBody sx={{ backgroundColor: '#ffffff' }}>
                      {pickupDetails?.map((row, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="center">{index + 1}</StyledTableCell>

                          <StyledTableCell>
                            <CTSinput
                              fullWidth
                              size="small"
                              variant="standard"
                              name="cyl_no"
                              value={row.cyl_no}
                              onChange={(e) => handleChangeInput(e, index)}
                              select
                              // InputProps={{ disableUnderline: true }}
                              InputProps={{ className: styles.CTSinput_Box }}
                            >
                              {cylinderList.map((cyl) => (
                                <MenuItem key={cyl.cyl_id} value={cyl.cylinder_no} className={`${styles.cts_lable}`}>
                                  {cyl.cylinder_no}
                                </MenuItem>
                              ))}
                            </CTSinput>
                          </StyledTableCell>
                          <StyledTableCell>
                            <CTSinput
                              fullWidth
                              size="small"
                              variant="standard"
                              name="prod_code"
                              value={row.prod_code}
                              readOnly
                              InputProps={{
                                disableUnderline: true,
                                style: { width: '80%' },
                              }}
                            />
                          </StyledTableCell>


                          <StyledTableCell>
                            <CTSinput
                              fullWidth
                              size="small"
                              variant="standard"
                              name="cyl_type"
                              value={row.cyl_type}
                              onChange={(e) => handleChangeInput(e, index)}
                              select
                              InputProps={{ className: styles.CTSinput_Box }}
                            // InputProps={{
                            //   disableUnderline: true,
                            //   style: {
                            //     width: '80%',
                            //   },
                            // }}
                            >
                              <MenuItem value="Empty" className={styles.cts_lable}>
                                Empty
                              </MenuItem>
                              <MenuItem value="Full" className={styles.cts_lable}>
                                Full
                              </MenuItem>
                            </CTSinput>
                          </StyledTableCell>


                          <StyledTableCell align="right">
                            <Box display="flex" justifyContent="center">
                              <IconButton size="small" onClick={handleAddSPQuotationFields}>
                                <AddIcon sx={{ fontSize: 16, color: "#1b52d1", border: "1px solid #1b52d1", borderRadius: "50%" }} />
                              </IconButton>

                              {index !== 0 && (
                                <IconButton size="small" onClick={() => handleRemovepickup(index)}>
                                  <DeleteForeverIcon sx={{ fontSize: 18, color: "red" }} />
                                </IconButton>
                              )}
                            </Box>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>


              <Grid item xs={12} className={`${styles.grid_input}`}>
                <Box className={`${styles.btn_container}`}>
                  <Box>
                    <Button
                      id={`${styles.btn_save}`}
                      type="submit"
                    >
                      <SaveIcon className={`${styles.btn_cancel_txt}`} />{" "}
                      <Typography className={`${styles.btn_cancel_txt}`}> {editData ? "Update" : "Save"}</Typography>
                    </Button>
                  </Box>
                  <Box>
                    <Cancel />
                  </Box>
                </Box>
              </Grid>

            </Grid>



          </form>
        </Box>


        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default AddPickupentry;
